<template>

	<div class="app-container">
			<div class="appTitle">{{title}}</div>
			<div class="appauthor" style="text-align: center;line-height: 80rpx;font-size: 28rpx;color: #CCCCCC;margin-top: 3%;">作者：{{ author }}</div>
		<div class="agreement" v-html="details"></div></div>
</template>

<script>
import { articleDetails } from '@/api/index';
export default {
	name: '',
	data() {
		return {
			title: '',//标题
			details: '',//内容
			id: '',//文字id
			author:""//作者名
		};
	},
	created(option) {
		this.getagreement(this.$route.query.id);
	},
	methods: {
		getagreement(id) {
			articleDetails(id).then(res => {
				this.author=res.data.author;
				this.title = res.data.title;
				this.details = res.data.content;
			});
		}
	}
};
</script>

<style lang="scss">
.app-container {
	width: 95%;
	margin: auto;
	margin-top: 3%;
	.appTitle{
		font-size: 40rpx;font-weight: bold;text-align: center;
	}
	img{
		width: 100%;
	}
}
</style>
